import template from './provider-status-content.html';
import './provider-status-content.scss';
import _ from 'lodash';
import { GrowthBookFeatures, hasGrowthBookFeature } from '../../modules/core';

class ProviderStatusModel {
  constructor(title, className) {
    this.title = title;
    this.className = className;
  }
}

export default angular
  .module('doxy.patient.providerStatusContent', [])
  .component('providerStatusContent', {
    template,
    bindings: {
      room: '<',
    },
    controller($timeout, $translate, pn, $log) {
      this.debug = $log.debug.bind($log, 'providerStatusContent');
      this.debug('init');
      this.numberOfDoctorsAvailable = 0;
      this.doctors = [];
      this.roomName = null;
      this.currentStatus = null;
      this.shouldHideProviderOnlineStatus = false;

      this.providerOfflineStatus = new ProviderStatusModel(
        $translate.instant('provider.status.offline'),
        'provider-status-content__data--offline'
      );

      this.providerAvailableStatus = new ProviderStatusModel(
        $translate.instant('provider.status.available'),
        'provider-status-content__data--available'
      );

      this.providerOnCallStatus = new ProviderStatusModel(
        $translate.instant('provider.status.on-call'),
        'provider-status-content__data--on-call'
      );

      this.updateStatusModel = () => {
        if (!this.doctors.length) {
          this.currentStatus = this.providerOfflineStatus;
        } else if (
          Boolean(
            this.doctors.some((doctor) => doctor.state.status === 'available')
          )
        ) {
          this.currentStatus = this.providerAvailableStatus;
        } else {
          this.currentStatus = this.providerOnCallStatus;
        }
      };

      this.updateRoomName = () => {
        if (this.doctors.length === 1 || Boolean(this.room.isPersonal)) {
          this.roomName = this.room.getDisplayName();
          return;
        }

        if (this.numberOfDoctorsAvailable > 0) {
          const translation =
            this.numberOfDoctorsAvailable === 1
              ? 'patient.status.one-provider-available'
              : 'patient.status.providers-available';
          this.roomName = $translate.instant(translation, {
            availableProvidersCount: this.numberOfDoctorsAvailable,
          });
          return;
        }

        this.roomName = $translate.instant('patient.status.all-providers');
      };

      this.getAvailableDoctorsCount = () => {
        return _.filter(this.doctors, (doctor) => {
          return doctor.state.status === 'available';
        }).length;
      };

      const updateStatus = () => {
        this.debug('updateStatus');
        $timeout(() => {
          this.numberOfDoctorsAvailable = this.getAvailableDoctorsCount();
          this.updateStatusModel();
          this.updateRoomName();
        });
      };

      const setDoctors = () => {
        this.doctors = pn.people.getUniqDoctors();

        this.doctors.forEach((doctor) => {
          doctor.addListenerIfNotExists('stateUpdate:status', updateStatus);
        });
      };

      const onPeopleUpdate = (person) => {
        this.debug('onPeopleUpdate');

        if (!person.isDoctor()) return;
        setDoctors();
        updateStatus();
      };

      const activate = () => {
        $timeout(() => {
          this.activated = true;
        });

        this.shouldHideProviderOnlineStatus = hasGrowthBookFeature(
          GrowthBookFeatures.HideProviderOnlineStatus
        );

        // Skip expensive operations if component will be hidden
        if (this.shouldHideProviderOnlineStatus) {
          return;
        }

        setDoctors();
        updateStatus();

        pn.on('join', onPeopleUpdate);
        pn.on('leave', onPeopleUpdate);
      };

      this.$onInit = () => {
        pn.connected ? activate() : pn.once('connected', activate);
      };

      this.$onDestroy = () => {
        pn.off('join', onPeopleUpdate);
        pn.off('leave', onPeopleUpdate);
        this.doctors.forEach((person) =>
          person.off('stateUpdate:status', updateStatus)
        );
      };
    },
  }).name;
